import { render, staticRenderFns } from "./emailRelationalDataTableConfig.vue?vue&type=template&id=3b7d3e06&scoped=true"
import script from "./emailRelationalDataTableConfig.vue?vue&type=script&lang=js"
export * from "./emailRelationalDataTableConfig.vue?vue&type=script&lang=js"
import style0 from "./emailRelationalDataTableConfig.vue?vue&type=style&index=0&id=3b7d3e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7d3e06",
  null
  
)

export default component.exports